<script setup lang="ts">
import { computed } from 'vue';
import * as icons from 'lucide-vue-next';

const props = withDefaults(defineProps<{
  name: string;
  size?: number;
}>(), {
  size: 16
});

const iconComponent = computed(() => {
  const iconName = props.name as keyof typeof icons;
  return icons[iconName] || icons.HelpCircle;
});
</script>

<template>
  <component 
    :is="iconComponent" 
    :size="size" 
    class="rad-icon inline-block shrink-0"
  />
</template>